import CoreLayoutContainer from './containers/CoreLayoutContainer';

export default CoreLayoutContainer;
